import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectFiltersState = (state: RootState) => state.filters;

export const selectIsLoading = createSelector(
  selectFiltersState,
  (filtersState) => filtersState.isLoading
);

export const selectFiltersValues = createSelector(
  selectFiltersState,
  (filtersState) => filtersState.values
);
